import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const GoogleIcon = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/Icon" {...props}>
      <g clipPath="url(#clip0_2374_6196)">
        <path
          d="M5.26623 9.765C5.73412 8.34945 6.63709 7.11781 7.84635 6.2458C9.0556 5.37378 10.5094 4.90594 12.0002 4.909C13.6902 4.909 15.2182 5.509 16.4182 6.491L19.9102 3C17.7822 1.145 15.0552 0 12.0002 0C7.27023 0 3.19823 2.698 1.24023 6.65L5.26623 9.765Z"
          fill="#EA4335"
        />
        <path
          d="M16.0403 18.0131C14.9503 18.7161 13.5663 19.0911 12.0003 19.0911C10.5154 19.0941 9.06711 18.63 7.86054 17.7644C6.65398 16.8988 5.75025 15.6757 5.2773 14.2681L1.2373 17.3351C2.22855 19.3414 3.76257 21.0295 5.66513 22.2076C7.56768 23.3858 9.76251 24.0068 12.0003 24.0001C14.9333 24.0001 17.7353 22.9571 19.8343 21.0001L16.0413 18.0131H16.0403Z"
          fill="#34A853"
        />
        <path
          d="M19.834 21.0001C22.029 18.9521 23.454 15.9041 23.454 12.0001C23.454 11.2901 23.345 10.5271 23.182 9.81812H12V14.4551H18.436C18.119 16.0141 17.266 17.2211 16.041 18.0131L19.834 21.0001Z"
          fill="#4A90E2"
        />
        <path
          d="M5.27712 14.2679C5.03247 13.5368 4.90819 12.7708 4.90912 11.9999C4.90912 11.2179 5.03412 10.4669 5.26612 9.7649L1.24012 6.6499C0.416494 8.31259 -0.00807994 10.1444 0.000116455 11.9999C0.000116455 13.9199 0.445116 15.7299 1.23712 17.3349L5.27712 14.2679Z"
          fill="#FBBC05"
        />
      </g>
      <defs>
        <clipPath id="clip0_2374_6196">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  );
};
